export interface SalesPurchaseProperty {
  id: string;
  key: string;
  heading: string;
  sales: boolean;
  salesString: string;
  purchases: boolean;
  purchasesString: string;
  text: boolean;
  textString: string;
  boolean: boolean;
  booleanString: string;
  printOnDocuments: boolean;
  printOnDocumentsString: string;
}
